import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Container, Img, SkeletonLoad, Wrapper, LogoDiv } from './styles';

function Header() {
  const history = useHistory();
  const configImage = useSelector(
    (state: ApplicationState) => state.config.assessoriaLogo
  );
  const secondaryLogo = useSelector(
    (state: ApplicationState) => state.config.urlLogoSecundario
  );
  const page = useSelector((state: ApplicationState) => state.auth.page);

  const handlerAction = (): void => {
    page === 'perfil' && history.goBack();
  };

  return (
    <Wrapper>
      <Container>
        <LogoDiv>
          {configImage !== '' ? (
            <Img src={configImage} onClick={handlerAction} />
          ) : (
            <SkeletonLoad width={200} />
          )}
          {secondaryLogo && <Img src={secondaryLogo} />}
        </LogoDiv>
      </Container>
    </Wrapper>
  );
}

export default Header;
